import { render, staticRenderFns } from "./ProfileRecommendation.html?vue&type=template&id=5339cc7e&scoped=true&"
import script from "./ProfileRecommendation.vue?vue&type=script&lang=js&"
export * from "./ProfileRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRecommendation.scss?vue&type=style&index=0&id=5339cc7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5339cc7e",
  null
  
)

export default component.exports